// removed by extract-text-webpack-plugin
module.exports = {"ctaWrapper":"ConfirmationModal-style__ctaWrapper__1b68bea8","button":"ConfirmationModal-style__button__1b68bea8","cancel":"ConfirmationModal-style__cancel__1b68bea8"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/ConfirmationModal-style.scss
// module id = 2622
// module chunks = 62